import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import styled from 'styled-components';

import CircularProgress from '@mui/material/CircularProgress';
import { ThemeProvider } from "@mui/material/styles";
import theme from "../style/theme.js";

import Logo from '../components/Logo.js';
import NavBar from '../components/NavBar.js';
import Footer from '../components/Footer.js';
import Element from '../components/Element.js';

import { apiListeElements } from '../api.js';

const Page = styled.div`
position:relative;
min-height:100vh;
overflow-y: scroll;
padding-bottom:300px;
`
const Title = styled.h2`
margin:0 auto;
`

const PageElements = () => {
    const {typeElement, nb, index} = useParams()

    const [elements, setElements] = useState(null)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(true)
    const [erreur, setErreur] = useState(false)

    useEffect(() => {

        apiListeElements(typeElement, nb, index)
        .then(res => {
            setElements(res.reponse.rows)
            setTotal(res.reponse.count)
            setLoading(false)
        })
        .catch(error => {
            console.log(error)
            setLoading(false)
            setErreur(true)
        })
    }, [typeElement, nb, index])

    return (
        <Page>
            <Logo/>
            <NavBar/>
            <Title>{typeElement} Théatra</Title>
            {! loading  && ! erreur && <h3>{typeElement} (au nombre total de {total})</h3> }
            { elements && elements.map(element => <Element key={element.id} type ={typeElement} elem={element} liste={true}/>)}
            {loading  && <ThemeProvider  theme={theme}><CircularProgress color="secondary"/><h3>Je charge</h3></ThemeProvider> }
            {erreur  && <h3>J'ai rencontré un problème...</h3> }

            <Footer/>
        </Page>
    )
}
export default PageElements